// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"(small: 0, medium: 768px, medium-large: 1080px, large: 1440px, xlarge: 1920px)"};